import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "inline-text" }
const _hoisted_2 = { class: "flex-row actions" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TextArea = _resolveComponent("TextArea")
  const _component_Button = _resolveComponent("Button")
  const _component_Segment = _resolveComponent("Segment")
  const _component_UploadItem = _resolveComponent("UploadItem")
  const _component_ScrollBar = _resolveComponent("ScrollBar")
  const _component_SampleItem = _resolveComponent("SampleItem")
  const _directive_resize = _resolveDirective("resize")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Segment, { class: "uploader-segment" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_TextArea, {
            modelValue: $data.inline_text,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.inline_text) = $event)),
            maxlength: _ctx.maxSize,
            rows: _ctx.txtRows,
            placeholder: $options.placeholder,
            disabled: !$options.can_type
          }, null, 8 /* PROPS */, ["modelValue", "maxlength", "rows", "placeholder", "disabled"]),
          _createElementVNode("div", _hoisted_2, [
            ($data.edit_id || $data.inline_text)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  tiny: "",
                  class: "button",
                  onClick: _cache[1] || (_cache[1] = $event => ($options.onDiscard()))
                }, {
                  default: _withCtx(() => _cache[6] || (_cache[6] = [
                    _createTextVNode(" Discard ")
                  ])),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            ($data.edit_id)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  tiny: "",
                  disabled: !$options.can_upload || !$options.diff,
                  primary: "",
                  class: "button",
                  onClick: _cache[2] || (_cache[2] = $event => ($options.onAddInlineText()))
                }, {
                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                    _createTextVNode(" Save ")
                  ])),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["disabled"]))
              : (_openBlock(), _createBlock(_component_Button, {
                  key: 2,
                  tiny: "",
                  disabled: !$data.inline_text || !$options.can_upload,
                  primary: "",
                  class: "button",
                  onClick: _cache[3] || (_cache[3] = $event => ($options.onAddInlineText()))
                }, {
                  default: _withCtx(() => _cache[8] || (_cache[8] = [
                    _createTextVNode(" Add ")
                  ])),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["disabled"]))
          ])
        ])
      ]),
      _: 1 /* STABLE */
    }),
    _createCommentVNode(" Uploads list "),
    (_ctx.uploads?.length)
      ? (_openBlock(), _createBlock(_component_Segment, {
          key: 0,
          class: "list"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ScrollBar, {
              ref: "uploads_scroll",
              style: _normalizeStyle({'height': _ctx.uploads_height})
            }, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createElementBlock("div", {
                  style: {"display":"grid","gap":"0.1rem"},
                  onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uploads, (upload) => {
                    return (_openBlock(), _createBlock(_component_UploadItem, {
                      id: upload.id,
                      key: upload.id,
                      ref_for: true,
                      ref: "uploads",
                      mode: _ctx.mode,
                      instance: upload,
                      class: "item",
                      inline: true,
                      onDelete: $event => (_ctx.store.deleteUpload(upload.id))
                    }, null, 8 /* PROPS */, ["id", "mode", "instance", "onDelete"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])), [
                  [_directive_resize, _ctx.onUploadsResize]
                ])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["style"])
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Files list "),
    (_ctx.files?.length)
      ? (_openBlock(), _createBlock(_component_Segment, {
          key: 1,
          class: "list"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ScrollBar, {
              ref: "files_scroll",
              style: _normalizeStyle({'height': _ctx.files_height})
            }, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createElementBlock("div", {
                  class: "flex-col",
                  style: {"gap":"0.1rem"},
                  onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files?.toReversed(), (file) => {
                    return (_openBlock(), _createBlock(_component_SampleItem, {
                      key: file.id,
                      ref_for: true,
                      ref: "files",
                      file: file,
                      class: "item",
                      mode: _ctx.mode,
                      onDelete: $event => ($options.onRemove(file.id)),
                      onDownload: $event => (_ctx.onDownload(file.id)),
                      onEdit: $event => ($options.onEdit(file.id, $event))
                    }, null, 8 /* PROPS */, ["file", "mode", "onDelete", "onDownload", "onEdit"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])), [
                  [_directive_resize, _ctx.onFilesResize]
                ])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["style"])
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}